import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

/**
 * Automatically unsubscribes from subscriptions in OnDestroy
 */
@Injectable()
export class DestroyBase implements OnDestroy {

  /**
   * Indicates if component is destroyed, e.g. ngOnDestroy has been called
   */
  protected destroyed = false;

  /**
   * The (list of) subscription(s)
   */
  protected subscriptions: Subscription = new Subscription();

  /**
   * Events to be unregistered
   */
  protected onEvents: Subscription[] = [];

  /**
   * Destroys the component
   */
  ngOnDestroy(): void {
    if (this.subscriptions.unsubscribe) {
      this.subscriptions.unsubscribe();
    }
    for (const subscription of this.onEvents) {
      if (subscription.unsubscribe) {
        subscription.unsubscribe();
      }
    }

    this.destroyed = true;
  }
}
